// Vue
import { Vue, Component, Prop, Inject, Watch } from "vue-property-decorator";

// Template
import template from "./template.vue";

@Component({
  mixins: [template],
})
export class ExpanderButton extends Vue {
  @Prop({ default: false })
  isExpanded!: boolean;

  @Prop({ default: false })
  disabled!: boolean;

  handleClick() {
    if (!this.disabled) {
      this.$emit("click", false);
    }
  }
}
